// extracted by mini-css-extract-plugin
export default {"attachment":"styles_attachment__aeB68","info":"styles_info__hdwLT","filename":"styles_filename__K5Nfg","date":"styles_date__LVYux","icon":"styles_icon__hHZ+X"};